import { useCallback, useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";
import { Reveal, SectionHeader } from "./Reveal";

const TESTIMONIALS = [
    {
        name: "Laysa Assis",
        text: "Há dois anos passando com Dr Gabriel e ele sempre impecável, atencioso, cuidadoso, sempre deixando tudo muito claro sobre os procedimentos, todo atendimento feito com calma, foco e precisão, ele passa muita confiança e todos os procedimentos que fiz com ele não senti absolutamente nenhuma dor. Profissional nota mil⭐️⭐️⭐️⭐️⭐️",
    },
    {
        name: "Stephanie Tavares",
        text: "Dr Gabriel é sensacional, mandei mensagem pra ele que estava com muita dor, precisando de uma consulta de emergência. Fiz um tratamento de canal indolor, não senti nada. Ele me deu todo suporte e atenção, explicou tudo nos mínimos detalhes e ganhou uma paciente nova.. Indico para todos!",
    },
    {
        name: "Rafael Amorim",
        text: "A consulta foi muito boa, o Dr Gabriel foi extremamente atencioso, explicou os procedimentos que foram feitos com bastante clareza, fez tudo bem feito e a o resultado foi praticamente instantaneo. Muito bom dentista e muita qualidade nos equipamentos e procedimentos. Recomendo para qualquer um que precise de tratamento odontológico!",
    },
    {
        name: "Francine Oliveira",
        text: "Estive em tratamento com o Dr Gabriel e só tenho a agradecer. Ambiente aconchegante, extremamente limpo. Atendimento acolhedor, humanizado e o tratamento em si (canal)... surreal! NADA DE DOR! Indico de olhos fechados. Obrigada Dr Gabriel 🙏",
    },
    {
        name: "Andy Vieira",
        text: "O Dr. Gabriel foi sempre muito atencioso e dedicado nos meus atendimentos, fez meu tratamento de canal com muita atenção e profissionalismo. Recomendo!",
    },
    {
        name: "Evelyn Ariadne Euzébio De Oliveira",
        text: "Dr. Gabriel é um excelente profissional! Me fez perder medo que eu tinha de muitos anos e alguns traumas. Muito atencioso, cuidadoso e competente. Explica tudo com clareza, transmite...",
    },
    {
        name: "Selma de Lourdes Amorim Rocha Amorim Rocha",
        text: "Atendimento de equipe excelente. O dentista Dr. Gabriel é muito atencioso, atende de forma muito humanizada, e tem uma mão bem leve, nem percebe que está realizando um tratamento dentário. Fiquei muito feliz e satisfeita com o atendimento.",
    },
    {
        name: "Raiane de Oliveira",
        text: "Ótimo atendimento! O dr. Gabriel muito atencioso e cuidadoso durante todo o procedimento, foi explicando o que estava fazendo, trazendo muita segurança e conforto.",
    },
    {
        name: "Carla Almeida",
        text: "Existem bons profissionais e excelentes profissionais, atendimento maravilhoso, profissional, de qualidade impecável e o principal...",
    },
    {
        name: "Marcella Mollmann",
        text: "Minha experiência com o Dr Gabriel foi maravilhosa, que atencioso, está de parabéns um profissional ótimo em Santos, vou indicar ele pra quem precisa 😍",
    },
    {
        name: "Vladimir Souza",
        text: "Gostaria de agradecer pelo cuidado e profissionalismo durante todo meu tratamento além de me sentir muito seguro.",
    },
    {
        name: "Maria Eduarda Bottiglieri Sbrana",
        text: "O Dr. Gabriel foi extremamente cuidadoso, atencioso e respeitoso. A consulta foi ótima do início ao fim. Tenho um carinho enorme por toda a família. Super recomendo!",
    },
    {
        name: "Guilherme Moreira",
        text: "O Dr. Gabriel é um excelente profissional. Muito atencioso, humano e cuidadoso em cada detalhe. Explica tudo com calma, o que deixa a gente tranquilo durante o atendimento. Me senti muito bem acolhido e fiquei muito satisfeito com o resultado. Recomendo de olhos fechados.",
    },
    {
        name: "Marcelo",
        text: "Dr Gabriel um excelente profissional, as 3 vezes que passei por ele, o doutor realizou os procedimentos de forma impecável, sempre muito profissional e muito bom no que faz, tão tranquilo eu fiquei que nem parece que eu estava no dentista.",
    },
    {
        name: "Jorge Lisboa",
        text: "Ótimo consultório Ótimo profissional durante o procedimento não senti nenhuma dor Ótimo dentista Dr.Gabriel esse é o Cara.",
    },
    {
        name: "Pedro Rocha",
        text: "Iniciei com muita apreensão, tendo vista o meu trauma, entretanto, foi muito tranquilo o procedimento executado.",
    },
    {
        name: "Cecilia Lima",
        text: "Excelente profissional, atencioso explica tudo para o paciente, pontual no atendimento. Perfeito o canal que fez no meu dente.",
    },
    {
        name: "Yone Ribeiro",
        text: "Maravilhosa! Apesar de estar sofrendo a um tempo, Dr. GABRIEL, com muito carinho e um profissionalismo esplêndido, resolveu meu problema, além de muito humanismo, muita gratidão.",
    },
    {
        name: "David Junior",
        text: "Um excelente profissional, meu atendeu super bem 🙏🏻",
    },
    {
        name: "Alessandra Stringhini",
        text: "Dentista maravilhoso, competente, capacitado, transmite confiança, segurança e tranquilidade no procedimento a ser realizado. Local agradável e confortável. Recomendo Dr. Gabriel sempre.",
    },
    {
        name: "Thamires Silva",
        text: "Ótimo profissional super tranquilo me passou segurança em todo atendimento.",
    },
    {
        name: "Benjamim Alves",
        text: "Muito boa a sensação de ter um excelente profissional nesse ramo. Super recomendo 😁",
    },
    {
        name: "Marcos Antônio",
        text: "Excelente profissional, explica todos os procedimentos em detalhes. E o que é melhor sem dor.",
    },
    {
        name: "Karoline Cabral",
        text: "Excelente profissional!! Pontual, muito focado, transmite muita segurança e tranquilidade. Todos os pacientes que foram atendidos em nossa clínica ficaram extremamente satisfeitos com o tratamento realizado. Além da capacidade técnica ainda...",
    },
    {
        name: "Cintia Moraes",
        text: "Eu recomendo, Dr. Gabriel superou as minhas expectativas, obrigada pela paciência e carinho.",
    },
    {
        name: "Anderson Gonçalves",
        text: "Um ser humano incrível! Como profissional não poderia ser diferente! Uma família linda, trabalhando juntos 🤗",
    },
    {
        name: "Tayná Nakasato",
        text: "⭐️⭐️⭐️⭐️⭐️ Profissional excelente! Competente, ético e, acima de tudo, muito humano. Os atendimentos são sempre acolhedores, o que faz toda a diferença, especialmente na...",
    },
    {
        name: "Guilherme Nascimento Pires",
        text: "Excelente profissional! Dr Gabriel é muito educado e experiente, atendimento foi maravilhoso, não troco por nada.",
    },
    {
        name: "Rodrigo Ferreira",
        text: "Fiz um canal com ele totalmente indolor! Nota dez!",
    },
    {
        name: "Mariana Silveira",
        text: "Excelente dentista. Atendimento humanizado ✅ muito esclarecedor e passa muita segurança!",
    },
    {
        name: "Allyson Israael",
        text: "Cara é bom exelente profissional recomendo 🤝🏻",
    },
    {
        name: "Cristina Pinheiro Lima",
        text: "Dr.Gabriel é um profissional extremamente competente, atencioso, me manteve a par de tudo durante todo o tratamento. Super recomendo.",
    },
    {
        name: "Berg Soares",
        text: "Excelente profissional, pontual e atencioso, recomendo.",
    },
    {
        name: "Arthur Moraes",
        text: "Dr Gabriel é ótimo! Explica todo o processo bem didático e tem um impecável atendimento. Recomendo sempre!",
    },
    {
        name: "Ana Karla Izidio",
        text: "Excelente profissional, muito atencioso. 👏",
    },
    {
        name: "Andre Martins",
        text: "Excelente profissional e super atencioso. Me salvou da dor, Recomendo d+",
    },
    {
        name: "Erika Jesus",
        text: "Dr Gabriel Riccio, muito paciente, prestativo atendimento top. Super recomendo. Fez o canal de um dente super indolor.",
    },
    {
        name: "Guilherme de Campos",
        text: "Doutor muito atencioso, educado e além disso um excelente profissional! Um especialista na área que exerce!!",
    },
    {
        name: "Gabriel Lemonaco",
        text: "Muito bom, saí satisfeito e feliz com o resultado 👏🫶",
    },
    {
        name: "Kauê Moura",
        text: "Ótimo atendimento, muito atencioso e cuidadoso. Com certeza voltarei ao consultório novamente.",
    },
    {
        name: "Nilo Piccoli",
        text: "Muito atencioso, profissional e mostrou bastante competência. Fiquei satisfeito com o resultado.",
    },
    {
        name: "Marcel Juliano",
        text: "Um ótimo dentista paciente e atencioso durante todo procedimento nota 10",
    },
    {
        name: "Gilvan Ferro",
        text: "Resolveu o problema das endodontias no meu consultório, passa muita calma e confiança pros pacientes.",
    },
    {
        name: "João Vitor Silva de Jesus",
        text: "Ótimo atendimento, muito paciente e atencioso, muito obrigado doutor 🙏🏾❤️",
    },
    {
        name: "Thaly Hy.",
        text: "Dr. Gabriel é muito atencioso e cuidadoso. Recomendo muito o atendimento!",
    },
    {
        name: "Marcos Eduardo",
        text: "Fui muito bem atendido pelo Dr Gabriel, impecável!!!",
    },
    {
        name: "Alexsandro Maier",
        text: "Ótimo dentista, foi super atencioso comigo e super cuidadoso no tratamento.",
    },
    {
        name: "Vicente Bibiano",
        text: "Atendimento rápido, cordial e eficiente.",
    },
    {
        name: "Fabio Vieira Soares",
        text: "Ótimo profissional... recomendo muito... tratamento excelente.",
    },
    {
        name: "Odonto Nômade",
        text: "Excelente profissional, uma honra tê-lo em minha equipe.",
    },
    {
        name: "Sonia Santos",
        text: "O Dr Gabriel é muito atencioso. Responde as dúvidas com clareza.",
    },
    {
        name: "Gabriel Duarte",
        text: "O melhor!",
    },
    {
        name: "Vinicius Mateus",
        text: "Muito atencioso e cuidadoso!! Recomendo de olhos fechados!",
    },
    {
        name: "Thalita Janini",
        text: "Atencioso, gentil e um excelente profissional!",
    },
    {
        name: "Lucas Magalhães",
        text: "Melhor endodontista da baixada santista, recomendo muito!",
    },
    {
        name: "Vanya Lima",
        text: "Dr muito calmo e passa isso para a gente.",
    },
    {
        name: "Gabriel Vieira",
        text: "Tirou totalmente minha dor! Doutor top.",
    },
    {
        name: "Obra Canal 1 Terracom",
        text: "Profissional de qualidade e ótimo atendimento!",
    },
    {
        name: "Victor Leal",
        text: "Muito boa, ótimo profissional.",
    },
    {
        name: "Lucas Castro",
        text: "Excelente profissional!!",
    },
    {
        name: "William Telfer",
        text: "Profissional nota 10.",
    },
    {
        name: "Emanuel Oliveira e Silva",
        text: "Trabalho excelente.",
    },
    {
        name: "Walberto Melarato",
        text: "Ótimo atendimento, atencioso e cuidadoso.",
    },
    {
        name: "Rose Lobo",
        text: "Dr Gabriel é extremamente competente, tranquilo, atencioso e não mede esforços para ver seus pacientes bem. Eu indico.",
    },
    {
        name: "Rita Anatalia Pedro",
        text: "O Dr Gabriel fez um atendimento ágil e eficiente, deixa a gente segura, já que só em falar de tratamento de canal deixa a gente bem apreensivo, mas correu tudo bem da maneira que ele previu, mesmo ele sempre se disponibilizando pra qualquer imprevisto. Por isso o indico sem medo.",
    },
    {
        name: "Lilian Tercia",
        text: "Fui muito bem atendida, acolhida pelo profissional, deixou a vontade, explicou tudo passo a passo, técnicas atualizadas, enfim, posso com certeza indicar o profissional.",
    },
    {
        name: "Valdeleide Nunes",
        text: "Excelente profissional 👏",
    },
    {
        name: "Thaina Samiramis",
        text: "Gostaria de ressaltar o excelente trabalho do Dr. Gabriel Riccio, um excelente profissional, atencioso e que trabalha com grande dedicação. Super recomendo!",
    },
    {
        name: "Alexandre Orsinetto Dr Alexandre",
        text: "Excelência define. Um especialista extremamente competente, cuidadoso e preciso. Fiz meu tratamento de canal sem sentir dor alguma. Minha total admiração e gratidão. Recomendo sem hesitar.",
    },
    {
        name: "Samy Nessim",
        text: "Excelente atendimento! O Dr. Gabriel foi muito atencioso e explicou tudo com clareza. Recomendo!",
    },
    {
        name: "Jardiele Kelly",
        text: "Otimooo",
    },
];

const PATIENT_PHOTOS = [
    { src: "/images/patients-1.png", alt: "Dr. Gabriel Riccio com paciente no consultório" },
    { src: "/images/patients-2.png", alt: "Dr. Gabriel Riccio com paciente no consultório" },
    { src: "/images/patients-3.png", alt: "Dr. Gabriel Riccio com paciente no consultório" },
    { src: "/images/patients-4.png", alt: "Dr. Gabriel Riccio com paciente no consultório" },
    { src: "/images/patients-5.png", alt: "Dr. Gabriel Riccio com paciente no consultório" },
    { src: "/images/patients-6.jpeg", alt: "Dr. Gabriel Riccio com paciente no consultório" },
];

const MAX_DOTS = 7;

export const Testimonials = () => {
    const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true, align: "start" });
    const [selected, setSelected] = useState(0);
    const [count, setCount] = useState(0);

    const onSelect = useCallback(() => {
        if (emblaApi) setSelected(emblaApi.selectedScrollSnap());
    }, [emblaApi]);

    useEffect(() => {
        if (!emblaApi) return;
        setCount(emblaApi.scrollSnapList().length);
        emblaApi.on("select", onSelect);
        onSelect();
    }, [emblaApi, onSelect]);

    const dotStart = Math.max(0, Math.min(selected - 3, count - MAX_DOTS));
    const visibleDots = Array.from(
        { length: Math.min(count, MAX_DOTS) },
        (_, k) => dotStart + k,
    );

    return (
        <section
            id="depoimentos"
            data-testid="testimonials-section"
            className="overflow-hidden bg-white py-24 md:py-32"
        >
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="flex flex-wrap items-end justify-between gap-6">
                    <SectionHeader
                        overline="Depoimentos"
                        title="A experiência de quem já passou por aqui"
                        subtitle="Atenção, cuidado e clareza fazem parte da experiência de atendimento."
                    />
                    <Reveal delay={0.2} className="hidden gap-3 sm:flex">
                        <button
                            type="button"
                            onClick={() => emblaApi && emblaApi.scrollPrev()}
                            aria-label="Depoimento anterior"
                            data-testid="testimonials-prev-button"
                            className="flex h-12 w-12 items-center justify-center rounded-full border border-slate-300 text-slate-700 transition-all hover:border-[#1A6AFF] hover:text-[#1A6AFF]"
                        >
                            <ChevronLeft className="h-5 w-5" />
                        </button>
                        <button
                            type="button"
                            onClick={() => emblaApi && emblaApi.scrollNext()}
                            aria-label="Próximo depoimento"
                            data-testid="testimonials-next-button"
                            className="flex h-12 w-12 items-center justify-center rounded-full border border-slate-300 text-slate-700 transition-all hover:border-[#1A6AFF] hover:text-[#1A6AFF]"
                        >
                            <ChevronRight className="h-5 w-5" />
                        </button>
                    </Reveal>
                </div>

                <Reveal delay={0.15}>
                    <div className="mt-14 cursor-grab active:cursor-grabbing" ref={emblaRef}>
                        <div className="flex">
                            {TESTIMONIALS.map((t, i) => (
                                <div
                                    key={`${t.name}-${i}`}
                                    className="min-w-0 flex-[0_0_100%] pr-5 sm:flex-[0_0_50%] lg:flex-[0_0_33.333%]"
                                >
                                    <figure
                                        data-testid={`testimonial-card-${i}`}
                                        className="flex h-full flex-col rounded-3xl border border-slate-200/80 bg-[#FAFCFF] p-8"
                                    >
                                        <Quote
                                            className="h-7 w-7 text-[#1A6AFF]"
                                            aria-hidden="true"
                                        />
                                        <blockquote className="mt-5 flex-1 text-sm leading-relaxed text-slate-600">
                                            “{t.text}”
                                        </blockquote>
                                        <figcaption className="mt-7 flex items-center gap-3 border-t border-slate-200/70 pt-5">
                                            <span
                                                className="flex h-10 w-10 items-center justify-center rounded-full bg-[#EFF5FF] font-heading text-sm font-bold text-[#1A6AFF]"
                                                aria-hidden="true"
                                            >
                                                {t.name
                                                    .split(" ")
                                                    .map((n) => n[0])
                                                    .slice(0, 2)
                                                    .join("")}
                                            </span>
                                            <span className="font-heading text-sm font-bold text-slate-900">
                                                {t.name}
                                            </span>
                                        </figcaption>
                                    </figure>
                                </div>
                            ))}
                        </div>
                    </div>
                </Reveal>

                <div className="mt-8 flex justify-center gap-2" data-testid="testimonials-dots">
                    {visibleDots.map((i) => (
                        <button
                            key={i}
                            type="button"
                            onClick={() => emblaApi && emblaApi.scrollTo(i)}
                            aria-label={`Ir para o depoimento ${i + 1}`}
                            data-testid={`testimonial-dot-${i}`}
                            className={`h-2 rounded-full transition-all duration-300 ${
                                i === selected ? "w-7 bg-[#1A6AFF]" : "w-2 bg-slate-300"
                            }`}
                        />
                    ))}
                </div>
                <p className="mt-6 text-center text-xs text-slate-400">
                    Relatos individuais de pacientes. Cada tratamento é avaliado e conduzido de forma
                    personalizada.
                </p>

                <div className="mt-20" data-testid="patient-photos-area">
                    <Reveal>
                        <h3 className="text-lg font-semibold text-slate-900 sm:text-xl">
                            Dr. Gabriel com seus pacientes
                        </h3>
                        <p className="mt-2 text-sm text-slate-500">
                            Registros reais de atendimentos no consultório.
                        </p>
                    </Reveal>
                    <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 sm:gap-5 lg:grid-cols-5">
                        {PATIENT_PHOTOS.map((photo, i) => (
                            <Reveal key={photo.src} delay={i * 0.06} className="h-full">
                                <div
                                    data-testid={`patient-photo-${i}`}
                                    className="group h-full overflow-hidden rounded-3xl border border-slate-200/80 shadow-sm"
                                >
                                    <img
                                        src={photo.src}
                                        alt={photo.alt}
                                        loading="lazy"
                                        className="aspect-[3/4] h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                                    />
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};
